import React from "react";
import { observer } from "mobx-react";
import { BotPhaseViewStore } from "../../store";
import { BotPhaseViewForm } from "./BotPhaseViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type BotPhaseViewProps = {
  botPhaseViewStore: BotPhaseViewStore;
};

export const BotPhaseView: React.FC<BotPhaseViewProps> = observer(
  ({ botPhaseViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <BotPhaseViewForm
          phaseNumber={botPhaseViewStore.phaseNumberValue}
          phaseId={botPhaseViewStore.phaseIdValue}
          phaseName={botPhaseViewStore.phaseNameValue}
          status={botPhaseViewStore.statusValue}
          stepsTotal={botPhaseViewStore.stepsTotalValue}
          stepsCompleted={botPhaseViewStore.stepsCompletedValue}
          startedAt={botPhaseViewStore.startedAtValue}
          completedAt={botPhaseViewStore.completedAtValue}
          duration={botPhaseViewStore.durationValue}
          error={botPhaseViewStore.errorValue}
          stepsLogPath={botPhaseViewStore.stepsLogPathValue}
          screenshotFiles={botPhaseViewStore.screenshotFiles}
          stepsVisibleColumns={botPhaseViewStore.stepsVisibleColumns}
          stepsSetColumnWiths={(x) => botPhaseViewStore.stepsSetColumnWiths(x)}
          stepsRows={botPhaseViewStore.stepsRowsDyn}
          onPrint={(handlePrint: () => void) =>
            botPhaseViewStore.printBotPhase(handlePrint)
          }
          onCancel={() => botPhaseViewStore.cancelBotPhase()}
          onEdit={
            botPhaseViewStore.isEditEnabled
              ? () => botPhaseViewStore.editBotPhase()
              : undefined
          }
          screenshotViewAction={getViewAction(
            (props) => botPhaseViewStore.fileDownload(props, "screenshot"),
            (props) => botPhaseViewStore.viewFilePdf(props, "screenshot")
          )}
        />
        <ErrorDialog
          open={botPhaseViewStore.errorDialogOpened}
          title={botPhaseViewStore.errorTitle}
          description={botPhaseViewStore.errorDescription}
          onClose={() => botPhaseViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={botPhaseViewStore.pdfViewerOpen}
          onClose={() => botPhaseViewStore.closePdfViewer()}
          pdfUrl={botPhaseViewStore.pdfViewerUrl}
          title={botPhaseViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
